<template>
  <Dialog
    :visible="visible"
    :closable="false"
    :modal="true"
    header="Generating PDF Preview"
    :style="{ width: '460px' }"
  >
    <div class="flex flex-col gap-4 py-1">
      <div class="text-sm text-gray-500 truncate">{{ contextLabel }}</div>

      <div class="font-medium text-gray-800 min-h-6">
        {{ label }}
      </div>

      <div class="text-sm text-gray-500 truncate min-h-5">
        {{ subLabel }}
      </div>

      <ProgressBar
        :value="percent"
        :style="{ height: '10px' }"
      />

      <div
        v-if="funMessage"
        class="text-xs text-indigo-400 italic text-center py-1 px-3 bg-indigo-50 rounded-lg"
      >
        {{ funMessage }}
      </div>

      <div class="flex justify-between items-center text-xs text-gray-400">
        <span>Step {{ current }} of {{ total }}</span>
        <span>{{ percent }}%</span>
      </div>

      <!-- Confirm-cancel row -->
      <div class="flex items-center justify-end gap-2 pt-1 min-h-9">
        <template v-if="confirmCancel">
          <span class="text-sm text-gray-600 mr-1">Cancel generation?</span>
          <Button
            label="Yes, cancel"
            icon="pi pi-check"
            severity="danger"
            size="small"
            @click="$emit('confirm-cancel')"
          />
          <Button
            label="Keep going"
            icon="pi pi-arrow-right"
            severity="secondary"
            variant="outlined"
            size="small"
            @click="$emit('dismiss-cancel')"
          />
        </template>
        <template v-else>
          <Button
            label="Cancel"
            icon="pi pi-times"
            severity="danger"
            variant="outlined"
            size="small"
            @click="$emit('cancel')"
          />
        </template>
      </div>
    </div>
  </Dialog>
</template>

<script>
  import { defineComponent } from "vue";

  export default defineComponent({
    name: "PdfProgressDialog",
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      contextLabel: {
        type: String,
        default: ""
      },
      label: {
        type: String,
        default: ""
      },
      subLabel: {
        type: String,
        default: ""
      },
      current: {
        type: Number,
        default: 0
      },
      total: {
        type: Number,
        default: 0
      },
      percent: {
        type: Number,
        default: 0
      },
      funMessage: {
        type: String,
        default: ""
      },
      confirmCancel: {
        type: Boolean,
        default: false
      }
    },
    emits: ["cancel", "confirm-cancel", "dismiss-cancel"]
  });
</script>
